module.exports = function () {
  return new Worker(__webpack_public_path__ + "a3ee8878207f085dcbbd.worker.js");
};